

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   assignLeaveTypesToUser,
//   fetchLeaveTypesMaster,
// } from "../../redux/actions/leaveTypeActions";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Select from "react-select"; // ✅ react-select for beautiful dropdown

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const AssignLeaveModal = ({ user, onClose }) => {
//   const dispatch = useDispatch();
//   const { masterLeaveTypes } = useSelector((state) => state.leaveType);

//   const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
//   const [remainingLeaves, setRemainingLeaves] = useState([]);

//   // Load master leave types for dropdown
//   useEffect(() => {
//     dispatch(fetchLeaveTypesMaster());
//   }, [dispatch]);

//   // Prefill and fetch user-specific leaves
//   useEffect(() => {
//     if (user?.leaveTypes) {
//       setSelectedLeaveTypes(
//         user.leaveTypes.map((lt) => ({ value: lt.id, label: lt.name }))
//       );
//     }
//     if (user?.id) {
//       fetchRemainingLeaves(user.id);
//     }
//   }, [user]);

//   // Fetch remaining leaves for user
//   const fetchRemainingLeaves = async (userId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(
//         `${BASE_URL}/v1/api/get_remaining_leavesByAdmin/${userId}`,
//         { headers: { authorization: token } }
//       );
//       setRemainingLeaves(res.data.data.leaves || []);
//     } catch (error) {
//       console.error("Failed to fetch remaining leaves:", error);
//     }
//   };

//   const handleSubmit = () => {
//     if (selectedLeaveTypes.length === 0) {
//       toast.error("Please select at least one Leave Type before saving!");
//       return;
//     }

//     dispatch(
//       assignLeaveTypesToUser(
//         user.id,
//         selectedLeaveTypes.map((lt) => lt.value)
//       )
//     );
//     onClose();
//   };

//   if (!user) return null;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 9999,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           padding: "24px",
//           borderRadius: "12px",
//           width: "650px",
//           maxHeight: "85vh",
//           overflowY: "auto",
//           boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
//         }}
//       >
//         <h2 style={{ marginBottom: "20px" }}>
//           Assign Leave Types to{" "}
//           <span style={{ color: "#2563eb" }}>{user.name}</span>
//         </h2>

//         {/* Multi-select dropdown for assigning leave types */}
//         <label
//           style={{ fontWeight: "600", display: "block", marginBottom: "8px" }}
//         >
//           Select Leave Types <span style={{ color: "red" }}>*</span>
//         </label>
//         <Select
//           isMulti
//           options={masterLeaveTypes.map((lt) => ({
//             value: lt.id,
//             label: lt.name,
//           }))}
//           value={selectedLeaveTypes}
//           onChange={(selected) => setSelectedLeaveTypes(selected || [])}
//           placeholder="Choose leave types..."
//           styles={{
//             control: (base) => ({
//               ...base,
//               borderRadius: "8px",
//               padding: "2px",
//             }),
//           }}
//         />

//         {/* Remaining Leaves Table */}
        
//       {/* Remaining Leaves Table */}
// <h3 style={{ marginBottom: "10px", marginTop: "25px" }}>
//   Remaining Leaves
// </h3>
// <div style={{ overflowX: "auto" }}>
//   <table
//     style={{
//       width: "100%",
//       borderCollapse: "collapse",
//       borderRadius: "8px",
//       overflow: "hidden",
//     }}
//   >
//     <thead style={{ background: "#2563eb", color: "#fff" }}>
//       <tr>
//         <th style={{ padding: "10px", textAlign: "left" }}>Leave Type</th>
//         <th style={{ padding: "10px", textAlign: "center" }}>Total</th>
//         <th style={{ padding: "10px", textAlign: "center" }}>Used</th>
//         <th style={{ padding: "10px", textAlign: "center" }}>Remaining</th>
//         <th style={{ padding: "10px", textAlign: "center" }}>Status</th> {/* ✅ NEW */}
//       </tr>
//     </thead>
//     <tbody>
//       {remainingLeaves.length > 0 ? (
//         remainingLeaves.map((leave) => (
//           <tr
//             key={leave.leave_type_id}
//             style={{ borderBottom: "1px solid #eee" }}
//           >
//             <td style={{ padding: "10px" }}>{leave.leave_type_name}</td>
//             <td style={{ padding: "10px", textAlign: "center" }}>
//               {leave.total_leaves}
//             </td>
//             <td style={{ padding: "10px", textAlign: "center" }}>
//               {leave.used_leaves}
//             </td>
//             <td
//               style={{
//                 padding: "10px",
//                 textAlign: "center",
//                 fontWeight: "600",
//                 color:
//                   parseInt(leave.remaining_leaves) > 0
//                     ? "#16a34a"
//                     : "#dc2626",
//               }}
//             >
//               {leave.remaining_leaves}
//             </td>
//             <td
//               style={{
//                 padding: "10px",
//                 textAlign: "center",
//                 fontWeight: "600",
//                 color: leave.status === "active" ? "#16a34a" : "#dc2626",
//                 textTransform: "capitalize",
//               }}
//             >
//               {leave.status}
//             </td>
//           </tr>
//         ))
//       ) : (
//         <tr>
//           <td
//             colSpan="5"
//             style={{
//               padding: "12px",
//               textAlign: "center",
//               color: "#666",
//             }}
//           >
//             No leave data available
//           </td>
//         </tr>
//       )}
//     </tbody>
//   </table>
// </div>


//         {/* Footer buttons */}
//         <div
//           style={{
//             marginTop: "20px",
//             display: "flex",
//             justifyContent: "flex-end",
//           }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               marginRight: "10px",
//               padding: "8px 14px",
//               borderRadius: "6px",
//               border: "1px solid #ccc",
//               background: "#f3f4f6",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             style={{
//               backgroundColor: "#2563eb",
//               color: "#fff",
//               padding: "8px 14px",
//               borderRadius: "6px",
//               border: "none",
//             }}
//           >
//             Save
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AssignLeaveModal;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  assignLeaveTypesToUser,
  fetchLeaveTypesMaster,
} from "../../redux/actions/leaveTypeActions";
import axios from "axios";
import toast from "react-hot-toast";
import Select from "react-select";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AssignLeaveModal = ({ user, onClose }) => {
  const dispatch = useDispatch();
  const { masterLeaveTypes } = useSelector((state) => state.leaveType);

  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [remainingLeaves, setRemainingLeaves] = useState([]);
  const [loadingStatuses, setLoadingStatuses] = useState({}); // track loading per leave type

  // Load master leave types
  useEffect(() => {
    dispatch(fetchLeaveTypesMaster());
  }, [dispatch]);

  // Prefill + fetch user-specific leaves
  useEffect(() => {
    if (user?.leaveTypes) {
      setSelectedLeaveTypes(
        user.leaveTypes.map((lt) => ({ value: lt.id, label: lt.name }))
      );
    }
    if (user?.id) {
      fetchRemainingLeaves(user.id);
    }
  }, [user]);

  // Fetch remaining leaves
  const fetchRemainingLeaves = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${BASE_URL}/v1/api/get_remaining_leavesByAdminDashbord/${userId}`,
        { headers: { authorization: token } }
      );
      setRemainingLeaves(res.data.data.leaves || []);
    } catch (error) {
      console.error("Failed to fetch remaining leaves:", error);
    }
  };

  // Handle status change: API call immediately
  const handleStatusChange = async (leaveTypeId, newStatus) => {
    setRemainingLeaves((prev) =>
      prev.map((leave) =>
        leave.leave_type_id === leaveTypeId
          ? { ...leave, status: newStatus }
          : leave
      )
    );
    setLoadingStatuses((prev) => ({ ...prev, [leaveTypeId]: true }));

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${BASE_URL}/v1/api/bulk_update_leave_type_status`,
        {
          user_id: user.id,
          leave_types: [{ leave_type_id: leaveTypeId, status: newStatus }],
        },
        { headers: { authorization: token } }
      );
      toast.success("Status updated successfully!");
    } catch (err) {
      console.error("Failed to update leave status:", err);
      toast.error("Failed to update status!");
      // rollback on error
      setRemainingLeaves((prev) =>
        prev.map((leave) =>
          leave.leave_type_id === leaveTypeId
            ? { ...leave, status: leave.status === "active" ? "inactive" : "active" }
            : leave
        )
      );
    } finally {
      setLoadingStatuses((prev) => ({ ...prev, [leaveTypeId]: false }));
    }
  };

  // Save handler for assigning leave types
  const handleSubmit = async () => {
    if (selectedLeaveTypes.length === 0) {
      toast.error("Please select at least one Leave Type before saving!");
      return;
    }

    try {
      await dispatch(
        assignLeaveTypesToUser(
          user.id,
          selectedLeaveTypes.map((lt) => lt.value)
        )
      );
      toast.success("Leave types assigned successfully!");
      onClose();
    } catch (err) {
      toast.error("Failed to assign leave types!");
    }
  };

  if (!user) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "24px",
          borderRadius: "12px",
          width: "650px",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>
          Manage Leave Types for{" "}
          <span style={{ color: "#2563eb" }}>{user.name}</span>
        </h2>

        {/* Assign Leave Types dropdown */}
        <label
          style={{ fontWeight: "600", display: "block", marginBottom: "8px" }}
        >
          Select Leave Types <span style={{ color: "red" }}>*</span>
        </label>
        <Select
          isMulti
          options={masterLeaveTypes.map((lt) => ({ value: lt.id, label: lt.name }))}
          value={selectedLeaveTypes}
          onChange={(selected) => setSelectedLeaveTypes(selected || [])}
          placeholder="Choose leave types..."
          styles={{ control: (base) => ({ ...base, borderRadius: "8px", padding: "2px" }) }}
        />

        {/* Remaining Leaves Table */}
        <h3 style={{ marginBottom: "10px", marginTop: "25px" }}>Remaining Leaves</h3>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", borderRadius: "8px", overflow: "hidden" }}>
            <thead style={{ background: "#2563eb", color: "#fff" }}>
              <tr>
                <th style={{ padding: "10px", textAlign: "left" }}>Leave Type</th>
                <th style={{ padding: "10px", textAlign: "center" }}>Total</th>
                <th style={{ padding: "10px", textAlign: "center" }}>Used</th>
                <th style={{ padding: "10px", textAlign: "center" }}>Remaining</th>
                <th style={{ padding: "10px", textAlign: "center" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {remainingLeaves.length > 0 ? (
                remainingLeaves.map((leave) => (
                  <tr key={leave.leave_type_id} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: "10px" }}>{leave.leave_type_name}</td>
                    <td style={{ padding: "10px", textAlign: "center" }}>{leave.total_leaves}</td>
                    <td style={{ padding: "10px", textAlign: "center" }}>{leave.used_leaves}</td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: parseInt(leave.remaining_leaves) > 0 ? "#16a34a" : "#dc2626",
                      }}
                    >
                      {leave.remaining_leaves}
                    </td>
                    {/* <td style={{ padding: "10px", textAlign: "center" }}>
                      <select
                        value={leave.status}
                        disabled={loadingStatuses[leave.leave_type_id]}
                        onChange={(e) =>
                          handleStatusChange(leave.leave_type_id, e.target.value)
                        }
                        style={{ padding: "4px 8px", borderRadius: "6px", border: "1px solid #ccc" }}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </td> */}
                    <td style={{ padding: "10px", textAlign: "center" }}>
  <select
    value={leave.status}
    disabled={loadingStatuses[leave.leave_type_id] || ["Casual leave", "Earned Leave"].includes(leave.leave_type_name)}
    onChange={(e) =>
      handleStatusChange(leave.leave_type_id, e.target.value)
    }
    style={{ padding: "4px 8px", borderRadius: "6px", border: "1px solid #ccc" }}
  >
    <option value="active">Active</option>
    <option value="inactive">Inactive</option>
  </select>
</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ padding: "12px", textAlign: "center", color: "#666" }}>
                    No leave data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer buttons */}
        <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{ marginRight: "10px", padding: "8px 14px", borderRadius: "6px", border: "1px solid #ccc", background: "#f3f4f6" }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{ backgroundColor: "#2563eb", color: "#fff", padding: "8px 14px", borderRadius: "6px", border: "none" }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignLeaveModal;
